import { useContext } from 'react'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import AnswerCountingInfoMobile from './AnswerCountingInfo.mobile'

const TentativeScoringDetailInfoMobile = () => {
  const { examGradingResultData } = useContext(
    PredictionOfPassedContainerContext,
  )

  const router = useRouter()

  const isGsat2025SecondRoute = router.pathname === '/prediction/gsat2025-2'

  const correctCount = examGradingResultData?.viewerResult.correctCount || 0
  const answeredCount = examGradingResultData?.viewerResult.answeredCount || 0

  const avgCorrectRate = answeredCount
    ? Math.round((correctCount / answeredCount) * 100)
    : 0

  return (
    <StyledWrapper>
      <AnswerCountingInfoMobile />
      <div className="percent-box">
        <p>정답률</p>
        <strong>{avgCorrectRate}%</strong>
        {isGsat2025SecondRoute && (
          <p className="correct-rate-guide-text">
            ⓘ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다.
          </p>
        )}
      </div>
    </StyledWrapper>
  )
}

export default TentativeScoringDetailInfoMobile

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  > .percent-box {
    width: 100%;
    padding: 12px 35px;
    border-radius: 10px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;

    > p {
      font-size: 16px;
      font-weight: normal;
      line-height: 1;
      letter-spacing: -0.64px;
      text-align: left;
      color: #333;
    }

    > strong {
      font-size: 28px;
      font-weight: bold;
      letter-spacing: -1.12px;
      text-align: left;
      color: #004eff;
    }

    .correct-rate-guide-text {
      ${({ theme }) => css`
        font-size: 13px;
        color: ${theme.color.text_2};
        text-align: center;
        line-height: 1.54;
      `}
    }
  }
`
